import { authedFetch } from '@/lib/authed-fetch';
import type {
  BroadcastDraft,
  BroadcastPreview,
  BroadcastWithRecipients,
} from '@sixam/shared/admin-broadcast-core';

async function parseApiResponse<T>(response: Response, fallbackMessage: string): Promise<T> {
  const payload = (await response.json().catch(() => null)) as ({ error?: string } & T) | null;

  if (!response.ok) {
    throw new Error(payload?.error ?? fallbackMessage);
  }

  return payload as T;
}

export async function fetchAdminBroadcasts(tenantSlug: string): Promise<BroadcastWithRecipients[]> {
  const response = await authedFetch(`/api/admin/${encodeURIComponent(tenantSlug)}/broadcasts`);
  return parseApiResponse<BroadcastWithRecipients[]>(response, 'Could not load broadcasts.');
}

export async function previewAdminBroadcast(
  tenantSlug: string,
  draft: BroadcastDraft
): Promise<BroadcastPreview> {
  const response = await authedFetch(
    `/api/admin/${encodeURIComponent(tenantSlug)}/broadcasts/preview`,
    {
      body: JSON.stringify(draft),
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
    }
  );
  return parseApiResponse<BroadcastPreview>(response, 'Could not preview broadcast.');
}

export async function sendAdminBroadcast(
  tenantSlug: string,
  draft: BroadcastDraft
): Promise<BroadcastWithRecipients> {
  const response = await authedFetch(`/api/admin/${encodeURIComponent(tenantSlug)}/broadcasts`, {
    body: JSON.stringify(draft),
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  });
  return parseApiResponse<BroadcastWithRecipients>(response, 'Could not send broadcast.');
}
